import { SvgIcon } from '@mui/material';
import { ReactComponent as AbandonedCartSvg } from './AbandonedCartSvg.svg';

export default function AbandonedCartIcon(props) {
    return (
        <SvgIcon component={AbandonedCartSvg} inheritViewBox {...props} />
    );
}
